<template>
  <div class="container">
    <form class="form-horizontal">
      <div class="form-group">
        <div class="col-xs-11">
          <a class="btn btn-success" v-link="'?paginate=no&page=1&routeStatus=1'">显示在前台显示的路线</a>
        </div>
      </div>
      <div class="form-group">
        <label class="col-xs-1 text-danger control-label">
          区域
        </label>
        <div class="col-xs-11">
          <label class="checkbox-inline" v-for="item in areas" track-by="$index">
            <input type="checkbox" v-model="search.city" :value="item.name"> {{item.name}}
          </label>
        </div>
      </div>
<!--       <div class="form-group">
        <label class="col-xs-1 text-danger control-label">
          状态
        </label>
        <div class="col-xs-11">
          <label class="checkbox-inline" v-for="(key, val) in status" track-by="$index">
            <input type="checkbox" v-model="val"> {{statusMap[key]}}
          </label>
        </div>
      </div> -->
      <div class="form-group">
        <label class="col-xs-1 text-danger control-label">分类</label>
        <div class="col-xs-11">
          <label class="checkbox-inline" v-for="item in categories" track-by="$index">
            <input type="checkbox" v-model="search.catalog" :value="item"> {{item}}
          </label>
        </div>
      </div>
      <div class="form-group">
        <label class="col-xs-1 text-danger control-label">青春路线</label>
        <div class="col-xs-11">
          <label class="checkbox-inline" v-for="(key, val) in youthOption" track-by="$index">
            <input type="checkbox" v-model="search.isYouthImplode" :value="key">{{val}}
          </label>
        </div>
      </div>
      <div class="form-group">
        <label class="col-xs-1 text-danger control-label">
          路线简称
        </label>
        <div class="col-xs-3">
          <input type="text" class="form-control" v-model="search.abbreviation">
        </div>
      </div>
      <div class="form-group">
        <label class="col-xs-1 text-danger control-label">
          路线标题
        </label>
        <div class="col-xs-3">
          <input type="text" class="form-control" v-model="search.heading">
        </div>
      </div>
      <div class="form-group">
        <div class="col-xs-offset-1 col-xs-3">
          <div class="row">
            <div class="col-xs-6">
              <button type="button" class="btn btn-block btn-default pull-right" @click="reset">reset</button>
            </div>
            <div class="col-xs-6">
              <button type="button" class="btn btn-block btn-primary" @click="click(queryList)($event)">搜索</button>
            </div>
          </div>
        </div>
        <div class="col-xs-8 text-right">
          <!-- <button class="btn btn-primary" @click="click(sort)($event)">保存排序</button> -->
          <a class="btn btn-success" v-link="'/tags'">标签管理</a>
          <a class="btn btn-success" @click.prevent="isShowCreateRoute = true">新增路线</a>
          <a class="btn btn-success" v-link="'/routes/carousel'">二级页面滚动图</a>
          <a class="btn btn-info" v-link="'/routes/trashed'">回收站</a>
        </div>
      </div>
    </form>
    <table class="table-v table table-striped table-hover">
      <thead>
        <tr>
          <th>
            #
          </th>
          <th>
            路线分类
          </th>
          <th>
            路线简称
          </th>
          <th>
            路线标题
          </th>
          <th>
            是否青春
          </th>
          <th>
            路线状态
          </th>
          <th>
            销售状态
          </th>
          <th>
            操作
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in list" :class="{'info': item.status != '1', 'danger': selectRoute === item}">
          <td>
            {{$index + 1}}
          </td>
          <td>
            【{{item.catalog}}】
          </td>
          <td class="text-primary">
          <a v-link="'product/trip?routeId=' + item.id ">{{item.abbreviation}}</a>
          </td>
          <td>
            {{item.heading}}
          </td>
          <td>{{tripIsYouth[item.isYouth]}}</td>
          <td>{{routeVisableStatus[item.status]}}</td>
          <td>{{item.saleStatus}}</td>
          <td>
            <div class="btn-group btn-group-sm" role="group" aria-label="Default button group">
              <a v-link="'/route/' + item.id + '/basic'" class="btn btn-default">编辑</a>
              <button @click="click(toggle)($event, item)" type="button" class="btn btn-default">{{ item.status != '1' ? '显示' : '隐藏'}}</button>
              <button @click="click(remove)($event, item.id)" type="button" class="btn btn-default">删除</button>
              <button @click="click(copy)($event, item.id)" type="button" class="btn btn-default">复制</button>
              <button @click="showCreateTrip(item)" type="button" class="btn btn-default">团期</button>
              <a href="{{siteUrl}}/route/{{item.id}}" target="blank" type="button" class="btn btn-default">预览</a>
            </div>
            <div class="btn-group btn-group-sm">
              <button @click="click(stick)($event, item)" type="button" class="btn btn-default">{{item.isStick ? '取消置顶': '置顶'}}</button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <nav class="text-center">
      <ul class="pagination">
        <li v-for="item in totalPage" track-by="$index"  :class="{active: $route.query.page == $index + 1}"><a v-link="'?page=' + ($index + 1)">{{$index+1}}</a></li>
      </ul>
    </nav>
    <create-route :show.sync="isShowCreateRoute" @callback="queryList"></create-route>
    <create-trip :route.sync="selectRoute" :show.sync="isShowCreateTrip"></create-trip>
  </div>
</template>

<script>
  import { tabset, tab, aside } from 'vue-strap'
  import config from '../../libs/config'
  import utils from '../../libs/utils'
  import createRoute from './CreateRoute'
  import createTrip from './CreateTrip'
  import { cloneDeep } from 'lodash'
  /*
    status
    1、显示
    2、隐藏
   */
  let search = {
    abbreviation: '',
    catalog: [],
    city: [],
    isYouthImplode: []
  }
  export default {
    data () {
      return {
        isShowCreateRoute: false,
        isShowCreateTrip: false,
        areas: config.areas,
        categories: config.categories,
        youthOption: ['否', '是'],
        siteUrl: config.siteUrl,
        routeVisableStatus: config.routeVisableStatus,
        tripIsYouth: config.tripIsYouth,
        list: [],
        search: cloneDeep(search),
        selectRoute: {},
        totalPage: 1
      }
    },
    components: {
      tabset,
      tab,
      aside,
      createRoute,
      createTrip
    },
    methods: {
      stick (route) {
        return this.$http.put(`${config.apiWe}/product/route/${route.id}`, {
          isStick: +!route.isStick
        })
        .then(() => {
          this.queryList()
        })
      },
      create (route) {
        return this.$http.post(config.apiWe + '/product/route', route)
          .then(() => {
            this.showRight = false
            this.queryList()
          })
      },
      queryList () {
        let params = {
          paginate: 'yes',
          page: 1
        }
        Object.assign(params, this.$route.query)
        Object.keys(this.search).forEach((key) => {
          if (Array.isArray(this.search[key]) && this.search[key].length) {
            params[key] = this.search[key].join(',')
          } else if (this.search[key]) {
            params[key] = this.search[key]
          }
        })

        return this.$http.get(config.apiWe + '/product/route?admin=yes&per=20', params)
          .then(({data}) => {
            this.$set('list', data['list'])
            this.$set('totalPage', data.totalPage)
          })
      },
      toggle (route) {
        /* eslint-disable eqeqeq */
        let status = route.status == '1' ? '2' : '1'

        return this.$http.put(`${config.apiWe}/product/route/${route.id}/status`, {status})
          .then(({data}) => {
            window.alert('切换显示隐藏成功')
            this.queryList()
          }, () => {
            window.alert('操作失败')
          })
      },
      copy (routeId) {
        return this.$http.post(`${config.apiWe}/product/route/${routeId}/copy`)
          .then(({data}) => {
            window.alert('复制成功')
            this.queryList()
          }, () => {
            window.alert('复制失败')
          })
      },
      remove (routeId) {
        if (window.confirm('确认删除？')) {
          return this.$http.delete(`${config.apiWe}/product/route/${routeId}`)
            .then(({data}) => {
              window.alert('删除成功')
              this.queryList()
            }, () => {
              window.alert('删除失败')
            })
        }
      },
      reset () {
        this.$set('search', cloneDeep(search))
      },
      showCreateTrip (route) {
        this.isShowCreateTrip = true
        this.selectRoute = route
      },
      handleDayClick (item) {
        item.accept = !item.accept
      },
      sort () {
        let data = this.list.map(({id}, order) => {
          return {
            id,
            order
          }
        })
        return this.$http.put(`${config.apiWe}/product/route/action/order`, JSON.stringify(data))
      },
      click: utils.click
    },
    route: {
      data ({next}) {
        this.queryList()
          .then(next)
      }
    }
  }
</script>

<style scoped>
  .table-v td {
    vertical-align: middle;
  }
</style>



/** WEBPACK FOOTER **
 ** List.vue?4b74eeff
 **/